import { IconV2Props } from '@withjoy/joykit';
import React from 'react';

export interface LayoutListItemProps
  extends Readonly<{
    id: string;
    title: string;
    subtitle: string;
    icon: React.MemoExoticComponent<React.ForwardRefExoticComponent<IconV2Props & React.RefAttributes<SVGSVGElement>>>;
    variant?: LayoutListVariant;
  }> {}

export enum LayoutListVariant {
  DEFAULT = 'default',
  SUPER_ADMIN_ONLY = 'superAdminOnly',
}

interface LayoutListItems
  extends Readonly<{
    children: ReadonlyArray<LayoutListItemProps>;
    id: string;
    title: string;
  }> {}

export interface LayoutListProps
  extends Readonly<{
    handleClose: () => void;
    items: ReadonlyArray<LayoutListItems>;
    loading: boolean;
    onItemClicked: (item: LayoutListItemProps) => void;
    subTitle: string;
    title: string;
  }> {}
